module.exports = __webpack_public_path__ + "static/aaa-c6570d344c62ee2ea2253a6453e3b949.svg";